import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import CircularProgress from '@mui/material/CircularProgress';
import { colors } from '../../css';
import { WithStylesClassesPropType } from '../../../lib/commonPropTypes';

const styles = (theme) => ({
  progress: {
    margin: theme.spacing(2),
    color: colors.colorBlue
  }
});

function Spinner(props) {
  const { classes, thickness, size, 'data-testid': testId } = props;
  return <CircularProgress data-testid={testId} className={classes.progress} size={size} thickness={thickness} />;
}

Spinner.propTypes = {
  classes: WithStylesClassesPropType.isRequired,
  size: PropTypes.number,
  thickness: PropTypes.number,
  'data-testid': PropTypes.string
};

Spinner.defaultProps = {
  size: 45,
  thickness: 4,
  'data-testid': ''
};

const StyledSpinner = withStyles(styles)(Spinner);
export default StyledSpinner;
